// !!!!
// This is a generated file.
// Do not manually change this file
// !!!!

export const Document_Type = {
    Picking_List: 3407872,
    Delivery_Note: 3407873,
    Invoice: 3407874,
    Accompanying_Invoice: 3407875,
    Credit_Note: 3407876,
    Return_From_Customer: 3407877,
    Receipt: 3407878,
    NonMinuscollected_Receipt: 3407879,
    Subconctractor_Delivery_Note: 3407880,
    Return_To_Supplier: 3407881,
    Correction_Invoice: 3407882,
    Invoice_For_Advance: 3407883,
    Correction_Accompanying_Invoice: 3407884,
    Correction_Receipt: 3407885,
    Paragon: 3407886,
    Correction_Paragon: 3407887,
    ProForma_Invoice: 3407888,
    Debit_Note: 3407889,
    Interstorage_movement_Document: 3407890,
    Production_Plan: 3407891,
    Fiscal_Bill: 3407892,
    InterStore_Movement_Document: 3407894,
    Shop_Transfer_Request_Document: 3407895,
    Order_List: 3407896,
    Sale_Cancellation_Invoice: 3407897,
    SelfInvoice: 3407898,
    SelfCredit_Note: 3407899,
    Delivery_Notes_From_Preshipping: 3407900,
};
